import { Components } from '@mui/material/styles/components';
import { Theme } from '@mui/material/styles/createTheme';
import { ThemeMuiAutocomplete } from './MuiAutocomplete';
import { ThemeMuiButton } from './MuiButton';
import {
  ThemeMUIDataTable,
  ThemeMUIDataTableBodyCell,
  ThemeMUIDataTableBodyRow,
  ThemeMUIDataTableHeadCell,
  ThemeMUIDataTablePagination,
  ThemeMUIDataTableSelectCell,
  ThemeMUIDataTableToolbar,
} from './MUIDataTable';
import { ThemeMuiToggleButton, ThemeMuiToggleButtonGroup } from './MuiToggleButton';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiAutocomplete: ThemeMuiAutocomplete,
  MuiButton: ThemeMuiButton,
  MUIDataTable: ThemeMUIDataTable,
  MUIDataTableToolbar: ThemeMUIDataTableToolbar,
  MUIDataTableBodyCell: ThemeMUIDataTableBodyCell,
  MUIDataTableBodyRow: ThemeMUIDataTableBodyRow,
  MUIDataTableHeadCell: ThemeMUIDataTableHeadCell,
  MUIDataTableSelectCell: ThemeMUIDataTableSelectCell,
  MUIDataTablePagination: ThemeMUIDataTablePagination,
  MuiToggleButton: ThemeMuiToggleButton,
  MuiToggleButtonGroup: ThemeMuiToggleButtonGroup,
};



